import React, { useEffect, useState } from "react";
import authService from "./AuthService";
import { Navigate } from "react-router-dom";

type OidcCallbackProps = {
    onLoginSuccess: () => void;
}

const OidcCallback: React.FC<OidcCallbackProps> = ({ onLoginSuccess }) => {
    const [isProcessing, setIsProcessing] = useState(true);
    const [loginSuccess, setLoginSuccess] = useState(false);

    useEffect(() => {
        let processed = false;
        
        const handleCallback = async () => {
            if (processed) return; // Prevent double processing
            processed = true;
            
            try {
                const success = await authService.handleOidcCallback();
                if (success) {
                    setLoginSuccess(true);
                    onLoginSuccess();
                } else {
                    setLoginSuccess(false);
                }
            } catch (error) {
                setLoginSuccess(false);
            } finally {
                setIsProcessing(false);
            }
        };

        handleCallback();
    }, []); // Empty dependency array to run only once

    if (isProcessing) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                flexDirection: 'column'
            }}>
                <h2>Processing OIDC Login...</h2>
                <p>Please wait while we complete your authentication.</p>
            </div>
        );
    }

    if (loginSuccess) {
        return <Navigate to="/" replace />;
    }

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            flexDirection: 'column'
        }}>
            <h2>Login Failed</h2>
            <p>There was an error processing your OIDC login. Please try again.</p>
            <button onClick={() => window.location.href = "/"}>Return to Login</button>
        </div>
    );
};

export default OidcCallback;